export default __webpack_public_path__ + "static/media/smallimage.facdac19.svg";